export const IntegrationType = {
    GoogleSheet: "integrate_google_sheets"
}